import { KeyValueMatchFilter } from "../../../param/generalSearchFilter";
import { ListDefinition } from "../../../param/listDefinitionType";
import { convertFlat } from "../commonLoop";
import { Result, ResultUnit } from "../generalSearchResult";
import { createKeyValueTable } from "../keyValueTable";

export const keyValueMatch = async ({
  query,
  listDefinitionsTable,
  result,
  workerContext,
}: {
  query: KeyValueMatchFilter;
  listDefinitionsTable: Record<string, ListDefinition>;
  result: Result;
  workerContext: any;
}) => {
  const dict = createKeyValueTable(result, listDefinitionsTable, query);
  if (!dict) {
    return [];
  }

  const _result = convertFlat(workerContext, result, (e: ResultUnit) => {
    const key = e.currentWord;
    const ret = (dict[key] ?? []).map((e2) => {
      const newe = JSON.parse(JSON.stringify(e));
      newe.currentWord = e2;
      return newe;
    });
    return ret;
  });
  return _result;
};